import ProcessDesignsModule from "./ProcessDesigns";
import ProcessDesignModule from "./ProcessDesign";
import TeamsModule from "./panel/Teams";
import SubscriptionModule from "./Subscription";
import CustomFlowModule from "./CustomFlow";
import PlayersModule from "./panel/Players";
import PanelModule from "./panel/Panel";
import ProcessesModule from "./panel/Processes";
import BusinessesModule from "./panel/Businesses";
import PreferencesModule from "./Preferences";
import ViewsModule from "./Views";
import CellsModule from "./Cells";
import SheetsModule from "./Sheets";
import GridsModule from "./panel/Grids";
import StructureTable from "./StructureTable";
import SmartSearchModule from "./SmartSearch";
import RangeStyleModule from "./RangeStyle";
import CornerModule from "./corners/Corner";
import StyleCornerModule from "./corners/StyleCorner";
import FormulaCornerModule from "./corners/FormulaCorner";
import RangeMovementModule from "./RangeMovement";
import { createStore } from "vuex";

import { i18n } from "../main";
import { Auth } from "aws-amplify";
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../utils/constants";
import { authorizationPlugin } from "./plugins/authPlugin";
import SatelliteCornerModule from "./corners/SatelliteCorner";

// Logger plugin to log dispatched actions
// const loggerPlugin = (store) => {
//   store.subscribeAction((action, state) => {
//     if (action.type !== "cells/setComment") console.log(`Action dispatched: ${action.type}`, action.payload);
//   });
// };
const store = createStore({
  namespaced: true,
  state() {
    return {
      authState: null,
      authUser: null,
      subscribePopupHidden:
        // yes and no conditions are only added because there are still some users with local storage values yes and no instead of true
        // and false. these conditions can safely be removed after some time
        localStorage.getItem("kk-subscribe-ad__ad-btn--hidden") == "yes"
          ? true
          : localStorage.getItem("kk-subscribe-ad__ad-btn--hidden") == "no"
          ? false
          : JSON.parse(localStorage.getItem("kk-subscribe-ad__ad-btn--hidden")),
      toasts: [],
      // for shortcuts with multiple keys
      clickedKeys: {},
      clickTimeout: null,
      activeContextMenu: {
        id: null,
        x: null,
        y: null,
        type: "",
      },
      activeScope: HotkeyScopes.ProcessDesigner,
      prevScopes: [],
      showProfileDialog: false,
      showBussinessDialog: false,
    };
  },
  mutations: {},
  actions: {
    addClickedKey({ commit, state, dispatch }, key) {
      clearTimeout(this.clickTimeout);

      state.clickedKeys[key] = true;

      this.clickTimeout = setTimeout(() => {
        state.clickedKeys = {};
      }, 2000);
    },
    setAuthState({ commit, state, dispatch }, value) {
      state.authState = value.state;
      state.authUser = value.user;
    },
    setSubscribePopupHidden({ commit, state, dispatch }, data) {
      localStorage.setItem("kk-subscribe-ad__ad-btn--hidden", JSON.stringify(data));
      state.subscribePopupHidden = data;
    },
    quotaReached({ commit, state, dispatch }, exp) {
      const emailAddress = exp.response.data.email;
      const transPrefix = "mybusiness.subscription.quota";
      const code = exp.response.data.code;

      if (code === "private-quota-reached" || code === "unsubscribed-team-create") {
        // when quota reached show subscribe ad btn issue #335
        dispatch("setSubscribePopupHidden", false);
      }

      function toastAction() {
        window.location.href =
          code === "private-quota-reached" || code === "unsubscribed-team-create"
            ? i18n.global.t(`subscribead.awsmpAppLink.${process.env.VUE_APP_AWS_MP_APP}`)
            : `mailto:${emailAddress}`;
      }

      dispatch(
        "addToast",
        {
          severity: "info",
          life: 120000,
          summary: i18n.global.t(`${transPrefix}.${code}.summary`),
          detail: i18n.global.t(`${transPrefix}.${code}.detail`, { emailAddress }),
          action: () => toastAction(),
        },
        { root: true }
      );
    },
    addToast({ commit, state, dispatch }, toast) {
      const id = `toast_${Math.random().toString().split(".")[1]}`;
      toast = { id: id, ...toast };
      if (toast.life == undefined) {
        toast.life = 3000;
      }

      state.toasts.push(toast);
      if (toast.life > 0) {
        setTimeout(() => dispatch("removeToast", id), toast.life);
      }
      return toast;
    },
    removeToast({ commit, state }, toastId) {
      state.toasts = [...state.toasts.filter((toast) => toast.id != toastId)];
    },
    setActiveContextMenu({ commit, state, dispatch }, { id, x, y, type = "sidebar" }) {
      state.activeContextMenu = {
        id,
        x,
        y,
        type,
      };
    },
    resetActiveContextMenu({ commit, state, dispatch }) {
      state.activeContextMenu = {
        id: null,
        x: 0,
        y: 0,
      };
    },
    setScope({ state }, newScope) {
      hotkeys.setScope(newScope);
      state.prevScopes = [...state.prevScopes, state.activeScope].slice(-10);
      state.activeScope = newScope;
    },
    toggleProfileDialog({ commit, state, dispatch }, data) {
      if (data === undefined) data = !state.showProfileDialog;
      state.showProfileDialog = data;
    },
    toggleBussinessDialog({ commit, state, dispatch }, data) {
      if (data === undefined) data = !state.showBussinessDialog;
      state.showBussinessDialog = data;
    },
    closeDesign({ dispatch }) {
      const resetModules = ["cells", "customFlow", "pdesign", "pdesigns", "table", "views", "sheets"];

      resetModules.forEach((module) => dispatch(`${module}/resetState`, null, { root: true }));
      dispatch("pdesign/resetOpenedItem", null, { root: true });
    },
  },
  getters: {
    user: (state) => async () => {
      return await Auth.currentAuthenticatedUser();
    },
    session: (state, getters) => async () => {
      return (await getters.user()).signInUserSession;
    },
  },
  modules: {
    pdesigns: ProcessDesignsModule,
    pdesign: ProcessDesignModule,
    teams: TeamsModule,
    subscription: SubscriptionModule,
    customFlow: CustomFlowModule,
    players: PlayersModule,
    panel: PanelModule,
    processes: ProcessesModule,
    businesses: BusinessesModule,
    grids: GridsModule,
    preferences: PreferencesModule,
    views: ViewsModule,
    cells: CellsModule,
    sheets: SheetsModule,
    table: StructureTable,
    smartSearch: SmartSearchModule,
    rangeStyle: RangeStyleModule,
    corners: CornerModule,
    styleCorner: StyleCornerModule,
    formulaCorner: FormulaCornerModule,
    satelliteCorner: SatelliteCornerModule,
    rangeMovement: RangeMovementModule,
  },
  plugins: [
    authorizationPlugin,
    // loggerPlugin
  ],
});

export default store;
